/**
 * Keeps the Terms and Privacy legal-document links in sync with the
 * Country dropdown on the registration form.
 *
 * The links are initially rendered with the country derived from the
 * Accept-Language header. When the user picks a different country the
 * hrefs must reflect that choice so they view the correct legal docs.
 */
export const initLegaldocLinks = () => {
  const countrySelect = document.getElementById('country_code');
  if (!countrySelect) return;

  const links = document.querySelectorAll('[data-legaldoc-type]');
  if (links.length === 0) return;

  countrySelect.addEventListener('change', () => {
    const country = encodeURIComponent(countrySelect.value);

    for (const link of links) {
      link.setAttribute('href', `/cw/cropwise_users/${link.dataset.legaldocType}/${country}`);
    }
  });
};
